import { tryParseJson } from './helper';
import { PostMessageData } from './models';

if (process.env.REACT_APP_SegmentIoKey) {
    analytics.load(process.env.REACT_APP_SegmentIoKey);

    window.addEventListener('message', (e) => {
        const data = tryParseJson(e.data) as PostMessageData;
        if (data && typeof data.roidata === 'object') {
        }
    });
}
